import React from 'react';
import {
  FaClock,
  FaEnvelope,
  FaPhone,
  FaWhatsapp,
  FaMapMarkerAlt
} from 'react-icons/fa';
import './SubJoinSection.css';
import { useNavigate } from 'react-router-dom';

const SubJoinSection = ({
  title = "",
  subtitle = "",
  subtitle1 = "",
  description = "Join VCNR Healthcare, a part of a growing hospital integrated system with leading hospitals, medical centres, health parks, and a newly expanding Institute of Health Science.",
  secondaryText = "Work with the local healthcare providers in roles across clinical, technical, admin, and outreach. Be part of one of the best hospitals near me, where meaningful work meets everyday learning.",
  image,
  showIcons = true,
  buttonText = "",
  secondButtonText = "Explore More",
  buttonLink,
  secondButtonLink
}) => {
  const navigate=useNavigate();
  return (
    <div className="subjoin-wrapper">
      <div className="subjoin-banner-container">
        <div className="subjoin-banner-left">
          <h2 className="subjoin-title">{title && title}</h2>
          <h3 className="subjoin-subtitle">{subtitle && subtitle}</h3>
          <p className="subjoin-description">{description}</p>
          <p className="subjoin-description">{secondaryText}</p>
<h3 className="subjoin-subtitle">{subtitle1 && subtitle1}</h3>
          {/* {showIcons && (
            <div className="subjoin-info">
              <p><FaClock /> Sun-Fri: 10.00–6.00</p>
              <p><FaEnvelope /> info@vcnrenterprise.com</p>
              <p><FaPhone /> +91 97397 89992</p>
              <p><FaWhatsapp /> VCNR Appointments - +91 63604 16666</p>
              <p><FaMapMarkerAlt /> VCNR Hospital Road, Micosample, Bangalore</p>
            </div>
          )} */}

          <div className="subjoin-buttons">
            {buttonText && <a href={buttonLink} target="_blank" rel="noopener noreferrer"><button className="explore-btn subjoin-button">{buttonText}</button></a>}
            {secondButtonText && <a href={secondButtonLink} target="_blank" rel="noopener noreferrer"><button className="explore-btn subjoin-button" onButtonClick={() => navigate("/Contact")}>{secondButtonText}</button></a>}
          </div>
        </div>
        <div className={window.location.pathname === '/Agrotech' || window.location.pathname === '/Hospitality' ? 'subjoin-banner-right1' : 'subjoin-banner-right'}>
          {image && <img src={image} alt="Visual" className="subjoin-image" />}
        </div>
      </div>
    </div>
  );
};

export default SubJoinSection;
